(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kohana-order')) {
 customElements.define('kohana-order',class extends HTMLElement {
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   this.form=this.closest('form');this.form.enctype='multipart/form-data';
   this.text=JSON.parse(this.querySelector('[data-ko-text]').textContent);
   this.date=this.querySelector('[data-ko-date]');this.plaque=this.querySelector('[data-ko-plaque]');this.purpose=this.querySelector('[data-ko-purpose]');
   this.pref=this.querySelector('[data-ko-pref]');this.city=this.querySelector('[data-ko-city]');this.street=this.querySelector('[data-ko-street]');this.island=this.querySelector('[data-ko-island]');this.result=this.querySelector('[data-ko-result]');
   this.zone='';this.revision=0;this.date.disabled=true;
   for(const el of [this.pref,this.city,this.street,this.island])el.addEventListener('input',()=>this.invalidate());
   this.querySelector('[data-ko-calculate]').addEventListener('click',()=>this.calculate());
   this.addEventListener('change',()=>this.update());
   this.addEventListener('focusin',()=>this.updateDate());
   this.form.addEventListener('submit',event=>{
    this.update();
    const valid=this.zone && this.zone!=='consult' && this.form.checkValidity();
    if(!valid){event.preventDefault();event.stopImmediatePropagation();const e=this.querySelector('.ko-error');e.textContent=this.zone?this.dataset.error:this.text.address_wait;e.hidden=false;if(!this.zone||this.zone==='consult'){this.querySelector('[data-ko-calculate]').focus();}else this.form.reportValidity();}
    else this.querySelector('.ko-error').hidden=true;
   },true);
   this.update();
  }
  invalidate(){this.revision++;this.zone='';this.date.value='';this.date.disabled=true;this.querySelector('[data-ko-zone]').value='';this.result.textContent=this.text.recheck;}
  normalize(s){return s.normalize('NFKC').replace(/[\s　]/g,'').replace(/[−ー―‐]/g,'-');}
  distance(lon,lat){const r=x=>x*Math.PI/180;const a=r(lat-35.5087062422222),b=r(lon-139.676480697778);const h=Math.sin(a/2)**2+Math.cos(r(lat))*Math.cos(r(35.5087062422222))*Math.sin(b/2)**2;return 6371*2*Math.asin(Math.sqrt(h));}
  async calculate(){
   const fields=this.querySelectorAll('[data-ko-address] input[required],[data-ko-address] select[required]');
   for(const el of fields){if(!el.checkValidity()){el.reportValidity();return;}}
   this.invalidate();const revision=this.revision;const button=this.querySelector('[data-ko-calculate]');button.disabled=true;
   const pref=this.pref.value;const city=this.normalize(this.city.value);const street=this.normalize(this.street.value);
   const remote=['北海道','青森県','岩手県','秋田県','鳥取県','島根県','岡山県','広島県','山口県','徳島県','香川県','愛媛県','高知県','福岡県','佐賀県','長崎県','熊本県','大分県','宮崎県','鹿児島県','沖縄県'];
   try{
    if(this.island.value!=='no'||remote.includes(pref)){this.zone='consult';this.result.textContent=this.text.consult;return;}
    this.result.textContent=this.text.checking;
    const response=await fetch('https://msearch.gsi.go.jp/address-search/AddressSearch?q='+encodeURIComponent(pref+city+street),{signal:AbortSignal.timeout(10000),credentials:'omit',referrerPolicy:'no-referrer'});
    if(!response.ok)throw Error('lookup');const data=await response.json();if(revision!==this.revision)return;
    const streetBase=street.replace(/[0-9０-９一二三四五六七八九十]+(?:丁目)?[-番地号].*$/,'').replace(/[0-9０-９]+.*$/,'');
    const exact=data.filter(x=>x.geometry?.type==='Point' && this.normalize(x.properties?.title||'').startsWith(pref+city+streetBase));
    if(exact.length!==1||!streetBase||exact[0].properties.title.length<=pref.length+city.length)throw Error('ambiguous');
    const [lon,lat]=exact[0].geometry.coordinates;if(!Number.isFinite(lon)||!Number.isFinite(lat))throw Error('coords');
    const km=this.distance(lon,lat);
    if(km>=14.5 && km<=15.5){this.zone='consult';this.result.textContent=this.text.consult;return;}
    this.zone=km<15?'local':'next';this.date.disabled=false;this.date.value='';this.updateDate();
   }catch(e){if(revision===this.revision){this.zone='';this.result.textContent=this.text.geo_fail;}}
   finally{button.disabled=false;}
  }
  updateDate(){
   if(!this.zone||this.zone==='consult')return;
   const parts=new Intl.DateTimeFormat('en-CA',{timeZone:'Asia/Tokyo',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',hourCycle:'h23'}).formatToParts(new Date());
   const p=Object.fromEntries(parts.map(x=>[x.type,x.value]));const day=new Date(Date.UTC(+p.year,+p.month-1,+p.day));
   const tomorrow=this.zone==='next'||+p.hour>=14;if(tomorrow)day.setUTCDate(day.getUTCDate()+1);
   const min=day.toISOString().slice(0,10);this.date.min=min;
   if(!this.date.value||this.date.value<min)this.date.value=min;
   this.date.setCustomValidity(this.date.value<min?this.text.date_error.replace('{date}',min):'');
   const label=this.zone==='next'?this.text.next_day:(tomorrow?this.text.after_cutoff:this.text.same_day);
   this.result.textContent=label+' '+this.text.date_ready.replace('{date}',min);
   this.querySelector('[data-ko-zone]').value=label;
  }
  update(){
   this.updateDate();
   const plaque=this.plaque.value==='立札'||this.plaque.value==='カード';const pf=this.querySelector('[data-ko-plaque-fields]');pf.hidden=!plaque;pf.querySelectorAll('input,textarea').forEach(x=>x.disabled=!plaque);this.querySelector('[data-ko-sender]').required=plaque;
   const venue=this.purpose.value==='ライブ・舞台・公演祝い'||this.purpose.value==='葬儀・告別式';const vf=this.querySelector('[data-ko-venue]');vf.hidden=!venue;vf.querySelectorAll('input,textarea').forEach(x=>{x.disabled=!venue;x.required=venue;});
   const names=[];this.querySelectorAll('[data-ko-file]').forEach(el=>{const file=el.files?.[0];const ok=!file||(/\.(pdf|jpg|jpeg|png|webp|heic|heif)$/i.test(file.name)&&file.size<=10*1024*1024);el.setCustomValidity(ok?'':this.text.file_error);if(file)names.push(file.name);});
   this.querySelector('[data-ko-files-status]').textContent=names.length?this.text.file_ready.replace('{files}',names.join(' ／ ')):'';
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
